(function () {
  'use strict';

  var selector = '.wb-dune-section';

  function getNow() {
    return new Date().getTime();
  }

  function getStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  }

  function removeStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
  }

  function copyText(text) {
    return new Promise(function (resolve, reject) {
      if (!text) {
        reject();
        return;
      }

      function fallbackCopy() {
        var textarea = document.createElement('textarea');

        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);

        try {
          var successful = document.execCommand('copy');
          document.body.removeChild(textarea);

          if (successful) {
            resolve();
          } else {
            reject();
          }
        } catch (error) {
          document.body.removeChild(textarea);
          reject(error);
        }
      }

      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
        navigator.clipboard.writeText(text)
          .then(resolve)
          .catch(function () {
            fallbackCopy();
          });
      } else {
        fallbackCopy();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.wbDuneReady === 'true') return;

    section.dataset.wbDuneReady = 'true';

    if (section.dataset.enable !== 'true') return;

    var sectionId = section.dataset.sectionId;
    var modal = section.querySelector('[data-wb-dune-modal]');
    var overlay = section.querySelector('[data-wb-dune-overlay]');
    var closeBtn = section.querySelector('[data-wb-dune-close]');
    var stickyBtn = section.querySelector('[data-wb-dune-sticky]');
    var copyBtn = section.querySelector('[data-wb-dune-copy]');
    var copyMsg = section.querySelector('.wb-dune-copy-msg');
    var mainContent = section.querySelector('.wb-dune-main');
    var successContent = section.querySelector('.wb-dune-success');
    var successStatus = section.querySelector('.wb-dune-status[data-status="success"]');

    if (!modal || !overlay) return;

    var isEditor = window.Shopify && window.Shopify.designMode;
    var delay = Math.max(parseInt(section.dataset.delay || '0', 10), 0) * 1000;
    var frequencyDays = Math.max(parseInt(section.dataset.frequency || '7', 10), 1);
    var closedKey = 'wbDune_' + sectionId + '_closedUntil';
    var subscribedKey = 'wbDune_' + sectionId + '_subscribed';
    var timer = null;

    function showSticky() {
      if (stickyBtn && section.dataset.showSticky === 'true') {
        stickyBtn.classList.add('is-visible');
      }
    }

    function hideSticky() {
      if (stickyBtn) {
        stickyBtn.classList.remove('is-visible');
      }
    }

    function open() {
      modal.classList.add('is-visible');
      overlay.classList.add('is-visible');
      document.body.classList.add('wb-dune-noscroll');
      hideSticky();
    }

    function close(saveState) {
      modal.classList.remove('is-visible');
      overlay.classList.remove('is-visible');
      document.body.classList.remove('wb-dune-noscroll');

      if (saveState && !isEditor) {
        setStorage(closedKey, String(getNow() + frequencyDays * 86400000));
      }

      showSticky();
    }

    function showSuccess() {
      section.classList.add('is-subscribed');

      if (mainContent) {
        mainContent.hidden = true;
      }

      if (successContent) {
        successContent.hidden = false;
      }
    }

    if (successStatus) {
      setStorage(subscribedKey, 'true');
      removeStorage(closedKey);
      showSuccess();
      window.setTimeout(open, 120);
    } else if (isEditor) {
      timer = window.setTimeout(open, 350);
    } else if (getStorage(subscribedKey) === 'true') {
      showSticky();
    } else {
      var closedUntil = parseInt(getStorage(closedKey) || '0', 10);

      if (!closedUntil || getNow() > closedUntil) {
        timer = window.setTimeout(open, delay);
      } else {
        showSticky();
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    overlay.addEventListener('click', function () {
      close(true);
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        open();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function (event) {
        event.preventDefault();

        var code = copyBtn.getAttribute('data-code') || copyBtn.dataset.code || '';

        if (!code) return;

        copyText(code)
          .then(function () {
            if (copyMsg) {
              copyMsg.textContent = 'Copié';
              window.setTimeout(function () {
                copyMsg.textContent = '';
              }, 1800);
            }
          })
          .catch(function () {
            if (copyMsg) {
              copyMsg.textContent = 'Copie impossible';
              window.setTimeout(function () {
                copyMsg.textContent = '';
              }, 1800);
            }
          });
      });
    }

    section._wbDuneClose = close;
    section._wbDuneOpen = open;
    section._wbDuneTimer = timer;
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(selector);

    if (section && section._wbDuneTimer) {
      window.clearTimeout(section._wbDuneTimer);
    }

    document.body.classList.remove('wb-dune-noscroll');
  });

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target.querySelector(selector);

    if (section && section._wbDuneOpen) {
      section._wbDuneOpen();
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var section = event.target.querySelector(selector);

    if (section && section._wbDuneClose) {
      section._wbDuneClose(false);
    }
  });
})();